// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 1024px) {\n  .input:focus ~ .label[data-v-eefdc828]::before {\n    background-color: #c6c6c6;\n  }\n}\n\n@media (min-width: 1024px) {\n  .input:focus:checked ~ .label[data-v-eefdc828]::before {\n    background-color: var(--magic-primary, #0c66ff);\n  }\n}", ""]);
// Exports
module.exports = exports;
